import React, { useState, useEffect } from 'react';
import '../../src/assets/css/style.css';
import footer from "../../src/assets/img/mainfooterbg.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getApplicantCertificateAppId } from "../CertificateService"
import { Link, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Modal from 'react-modal';
import Navbar from "./Navbar";
import { postNumberVerification, postOtpVerification, } from "../CertificateService";

const StatusApplication = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    console.log(params.get('evnt_index'), "papapa")
    console.log([...params])
    const handleCloseDelete = () => setShowDelete(false);
    const [showDelete, setShowDelete] = useState(false);
    const [achievementList, setAchievementList] = useState([]);
    const [integerValue, setIntegerValue] = useState(null);
    const [blockList, setBlockList] = useState();
    const [userData, setUserData] = useState(null);
    const [remark, setRemark] = useState("");
    const [applicantId, setApplicantId] = useState(null);

    const [mobileNumber, setMobileNumber] = useState();
    const [isValidMobile, setIsValidMobile] = useState(true);
    // const [otp, setOtp] = useState();
    const [isValidOtp, setIsValidOtp] = useState(true);
    const [sendOtp, setSendOtp] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [resendTimer, setResendTimer] = useState(30);

    const [certificateDataList, setCertificateDataList] = useState();

    const [otp, setOtp] = useState(); // State to store OTP input
    const [generatedOtp, setGeneratedOtp] = useState(null); // State to store generated OTP
    const [isOtpVerified, setIsOtpVerified] = useState(false); // State for success message
    const [errorMessage, setErrorMessage] = useState(""); // State for error message
    const [timer, setTimer] = useState(0); // State for timer

    const [isChecked, setIsChecked] = useState(false); // State for success message



    useEffect(() => {
        const jsonString = localStorage.getItem("Certificate_user");
        console.log(jsonString, "string")
        const data = JSON.parse(jsonString);
        setUserData(data);
    }, []);


    const onVerify = () => {

        console.log("verifyyyyyyyyyyyyyy")
        if (!otp) {
            toast.error("Please Type 4 digit OTP")
        } else {
            postOtpVerification(mobileNumber, otp, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    const dataMobile = { "mobile": mobileNumber }
                    localStorage.setItem("Certificate_user", JSON.stringify(dataMobile));

                    toast.success("OTP Verified successfully")
                    navigate("/add-certificate");

                } else {
                    toast.error("Invalid Otp")
                }
            })

        }

    }


    const onSend = (e) => {
        if (!mobileNumber) {
            toast.error("Please Enter your mobile number")
        } else {
            postNumberVerification(mobileNumber, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    toast.success("OTP has been send successfully")
                    setSendOtp(true)
                    startResendTimer();
                } else {
                    toast.error(res.message)
                }
            })


            // setSendOtp(true)
        }
    }

    const resendOtp = () => {
        onSend();
    };

    const startResendTimer = () => {
        setResendTimer(30); // Reset timer to 30 seconds
        const timerInterval = setInterval(() => {
            setResendTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(timerInterval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const onMobile = (e) => {
        const inputValue = e.target.value;

        // Only allow numbers and limit to 10 digits
        if (inputValue.length <= 10 && /^[0-9]*$/.test(inputValue)) {
            setMobileNumber(inputValue);
        }
    };


    const onApplicationId = (e) => {
        setApplicantId(e.target.value)
    }

    const onSearch = () => {
        if (!applicantId) {
            toast.error("Please enter application id");
        } else {

            getApplicantCertificateAppId(applicantId).then(function (result) {
                const response = result?.data;
                setCertificateDataList(response);
            });
        }
    }

    const onCheckNext = () => {
        setApplicantId("");
        setCertificateDataList("");
    }



    return (
        <div>


            <ToastContainer />
            <div className='container-fluid'>
                <div className='dbMain businessUnit'>
                    <div className='dbRight'>
                        {/* <Navbar /> */}

                        {/* <Header link="/dashboard" breadcm="Configuration > " title="Business unit" description="There are many variations of passages of Lorem Ipsum available." /> */}
                        <div className="grid-container">
                            <div
                                className="grid-x align-center align-middle"
                                style={{ height: "30vh", padding: "10px" }}
                            >
                                <div className="cell small-12 medium-8 large-6">
                                    <h3
                                        className="text-center"
                                        style={{
                                            color: "#ff5722",
                                            fontSize: "22px",
                                            marginBottom: "15px",
                                            display: "flex",
                                            justifyContent: "center",
                                            fontWeight:"bold"
                                        }}
                                    >
                                        Check Your Application Status
                                    </h3>
                                    <div
                                        className="input-group"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center", // Center align the input and button
                                        }}
                                    >
                                        <input
                                            value={applicantId}
                                            type="Number"
                                            placeholder="Enter Your Application ID"
                                            style={{
                                                borderRadius: "10px",
                                                border: "2px solid #ff9800",
                                                width: "50%", // Set to half the container width
                                                padding: "10px",
                                                fontSize: "16px",
                                                marginRight: "10px", // Add spacing between input and button
                                            }}
                                            onChange={onApplicationId}
                                        />
                                        <button
                                            className="button"
                                            style={{
                                                backgroundColor: "#ff9800",
                                                borderRadius: "20px",
                                                color: "black",
                                                padding: "8px 10px",
                                                fontSize: "16px",
                                            }}
                                            onClick={onSearch}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {certificateDataList ?
                            <div className="card">
                                <h3 className="card-title">Application ID - {certificateDataList?.APPLICATION_ID ? certificateDataList?.APPLICATION_ID : certificateDataList}</h3>
                                <div className="card-content">
                                    <div className="row">
                                        <div className="col">Applicant Name</div>
                                        <div className="col highlight">{certificateDataList?.NAME_APPLI ? certificateDataList?.NAME_APPLI : certificateDataList}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col">Mobile No</div>
                                        <div className="col highlight">{certificateDataList?.MOBILE_NO ? certificateDataList?.MOBILE_NO : certificateDataList}</div>
                                        {/* <div className="col">Amount Adjusted</div>
                                    <div className="col highlight">2121</div> */}
                                    </div>

                                    <div className="row">
                                        <div className="col">Status</div>
                                        <div className="col highlight">{certificateDataList?.STATUS ? certificateDataList?.STATUS : certificateDataList}</div>

                                    </div>

                                    <div className="row">
                                        <div className="col">Location</div>
                                        <div className="col highlight">{certificateDataList?.DIST_NAME ? certificateDataList?.DIST_NAME : certificateDataList}-
                                        {certificateDataList?.BLOCK_NAME ? certificateDataList?.BLOCK_NAME : certificateDataList}-
                                        {certificateDataList?.GP_NAME ? certificateDataList?.GP_NAME : certificateDataList}
                                        </div>

                                    </div>
                                    {certificateDataList?.STATUS == "Ready To Download" ?
                                        <button className="card-button-download" onClick={() => setShowModal(true)}>Download Certificate</button> : ""}

                                </div>
                                <button className="card-button" onClick={onCheckNext}>Check Next Application</button>
                            </div> : ""}

                        {/* {!certificateDataList ?
                            <h3 className="card-title">No Data Found on this Application ID - {applicantId}</h3>
                            : ""} */}

                    </div>
                    {showModal && (
                        <div
                            className="modal-overlay"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            }}
                        >
                            <div
                                className="card"
                                style={{
                                    width: "400px",
                                    backgroundColor: "#fff",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                    position: "relative",
                                }}
                            >
                                <div className="header">
                                    <h1 style={{ color: "green" }}>Citizen Corner</h1>
                                    <h2 style={{ color: "black" }}>Citizen Sign Up</h2>
                                </div>
                                <div className="content">
                                    {/* Close Modal Button */}
                                    <button
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            background: "none",
                                            border: "none",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setShowModal(false)}
                                    >
                                        &times;
                                    </button>
                                    <div className="otp-form">

                                        <input
                                            type="number"
                                            id="userOTP"
                                            placeholder="Enter Mobile Number"
                                            maxLength={10}
                                            value={mobileNumber}
                                            onChange={onMobile}

                                            style={{ marginRight: "10px", padding: "5px" }}
                                        />
                                    </div>
                                    {sendOtp ?
                                        <div className="otp-form">
                                            <input
                                                type="text"
                                                id="userOTP"
                                                placeholder="Enter OTP"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}

                                                style={{ marginRight: "10px", padding: "5px" }}
                                            />
                                            <button
                                                onClick={onVerify}

                                            >
                                                Verify & Proceed
                                            </button>
                                        </div> : ""}
                                    {/* Generate OTP Button */}
                                    {sendOtp ? "" :
                                        <button id="generateBtn" onClick={onSend}>
                                            Generate OTP
                                        </button>}

                                    {sendOtp ?

                                        <div style={{ marginTop: "10px" }}>
                                            <button
                                                id="generateBtn"
                                                onClick={resendOtp}
                                                style={{
                                                    padding: "10px",
                                                    width: "100%",
                                                    backgroundColor: resendTimer > 0 ? "#ccc" : "#007bff",
                                                    color: "#fff",
                                                    cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                                                }}
                                                disabled={resendTimer > 0}
                                            >
                                                {resendTimer > 0
                                                    ? `Resend OTP in ${resendTimer}s`
                                                    : "Resend OTP"}
                                            </button>
                                        </div> : ""}
                                    {/* OTP Form */}


                                    {/* Success Message */}
                                    {isOtpVerified && (
                                        <div className="success-message" style={{ color: "green", marginTop: "10px" }}>
                                            <i className="fas fa-check"></i>
                                            <p>Congratulations! OTP is Verified!</p>
                                        </div>
                                    )}

                                    {/* Error Message */}
                                    {errorMessage && (
                                        <div className="error-message" style={{ color: "red", marginTop: "10px" }}>
                                            {errorMessage}
                                        </div>
                                    )}

                                    {/* Timer */}
                                    {generatedOtp && timer > 0 && (
                                        <div className="timer" style={{ marginTop: "10px" }}>
                                            OTP expires in <b>{timer} seconds</b>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>


            <nav className="footer" >
                <img src={footer} style={{ marginTop: "350px" }} />
                <p className="text-center lastp" style={{ fontSize: "16px !important" }}><strong>©</strong>
                    2024 Designed and Developed By <b>IT And Statistical Cell,</b> Panchayat & Rural
                    Development Department <b>Govt. of West Bengal</b>
                </p>
                <p className="text-center lastp" style={{ fontSize: "14px !important" }}>Site best viewed with 1920x1080 resolution in
                    Google Chrome 31.0.1650.63, Firefox 55.0.2, Safari 5.1.7 & IE 11.0 and above</p>
            </nav>

        </div>

    )
}

export default StatusApplication;